module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-program"
  }, [_c('app-navigation', {
    attrs: {
      "hideAuxNavOnDesktop": true,
      "currentSpace": _vm.$tc('web.program.nav_space', _vm.programs.length)
    }
  }), _vm._v(" "), (!_vm.access_denied) ? _c('main', {
    staticClass: "o-program__main"
  }, _vm._l((_vm.programs), function(program) {
    return _c('router-link', {
      key: program.id,
      staticClass: "c-card c-card--program qa-program-card",
      class: ('t-program-card-' + program.id),
      attrs: {
        "to": {
          name: 'Program',
          params: {
            id: program.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "c-card--program__visual"
    }, [_c('img', {
      attrs: {
        "src": _vm.programImages[program.id].program_thm,
        "alt": _vm.$t('web.programs.alt_text_logo'),
        "srcset": _vm.programImages[program.id].program_thm + ' 160w, ' +
          _vm.programImages[program.id].program_thm_350 + ' 350w, ' +
          _vm.programImages[program.id].program_thm_700 + ' 700w'
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "c-card--program__info t-program-id__info"
    }, [_c('h2', {
      staticClass: "c-card--program__info__title t-program-id__info__title"
    }, [_vm._v(_vm._s(program.name))]), _vm._v(" "), _c('p', {
      staticClass: "c-card--program__info__desc t-program-id__info__desc"
    }, [_vm._v(_vm._s(program.description))])])])
  }), 1) : _c('main', {
    staticClass: "o-program__main"
  }, [_c('h1', {
    staticClass: "c-card--program-header__info__title t-program__info__title"
  }, [_vm._v(_vm._s(_vm.$t('web.program_dashboard.no_access')))])]), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6461d5e0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ProgramDashboard.vue
// module id = 545
// module chunks = 1